module.exports = __webpack_public_path__ + "img/block_6.7a1c3d80.webp";